"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var armies_1 = require("../../armies");
var services_1 = require("../../services");
var types_1 = require("../../types");
var types_2 = require("./types");
var defaultState = {
    board: [],
    currentPlayer: 0,
    decks: [],
    phase: types_1.Phases.Init,
    playerHand: [],
    round: 0
};
function gameReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case types_2.GAME_INIT: {
            var board = [
                [null, null, null],
                [null, null, null, null],
                [null, null, null, null, null],
                [null, null, null, null],
                [null, null, null]
            ];
            console.log('gameReducer GAME_INIT', action.armies);
            var decks = action.armies
                .map(function (army) { return armies_1.armies[army]; })
                .map(function (army) { return services_1.shuffle(army.deck); });
            var currentPlayer = services_1.getRandomInt(action.armies.length);
            var phase = types_1.Phases.HQ;
            var playerHand = [armies_1.armies[action.armies[currentPlayer]].hq];
            var round = 0;
            return __assign({}, state, { board: board, currentPlayer: currentPlayer, decks: decks, phase: phase, playerHand: playerHand, round: round });
        }
        case types_2.GAME_TILE_DROP: {
            var col_1 = action.col, row_1 = action.row, tile_1 = action.tile;
            console.log('gameReducer GAME_TILE_DROP', state.board);
            var board = state.board.map(function (column, i) { return column.map(function (cell, j) { return i === col_1 && j === row_1 ? tile_1 : cell; }); });
            return __assign({}, state, { board: board });
        }
        default:
            return state;
    }
}
exports.gameReducer = gameReducer;
